import * as Types from '../types/SubscriptionTransaction';
import {PAGINATION} from '../../constants/define';
// import HotelRequest from "../mapping/Request/HotelRequest";

const initialState = {
    isFetching: false,
    all: [],
    errors: [],
    masterData: {},
    // item: new HotelRequest().update(),
    item: {},
    data: {
        result: [],
        page_size: PAGINATION.page_size,
        page_index: PAGINATION.page_index,
        total: PAGINATION.total,
        total_page: PAGINATION.total_page,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.SUBSCRIPTION_TRANSACTION_LIST_ACTION:
            return {...state, isFetching: true};
        case Types.SUBSCRIPTION_TRANSACTION_LIST_SUCCESS:
            return {...state, isFetching: false, data: action.subscriptionTransactions};
        case Types.SUBSCRIPTION_TRANSACTION_MASTER_ACTION:
            return {...state, isFetching: true};
        case Types.SUBSCRIPTION_TRANSACTION_MASTER_SUCCESS:
            return {...state, isFetching: false, masterData: action.masterData};
        case Types.SUBSCRIPTION_TRANSACTION_UPDATE_ACTION:
            return {...state, isFetching: true};
        case Types.SUBSCRIPTION_TRANSACTION_UPDATE_SUCCESS:
            return {...state, isFetching: false};
        case Types.SUBSCRIPTION_TRANSACTION_FAILED:
            return {...state, isFetching: false, errors: action.errors};
        case Types.SUBSCRIPTION_TRANSACTION_INIT:
            return initialState;
        default:
            return state;
    }
}
